// AUTO-GENERATED by mercato generate registry
import type { ComponentType } from 'react'
import type {
  MessageTypeDefinition,
  MessageObjectTypeDefinition,
  MessageListItemProps,
  MessageContentProps,
  MessageActionsProps,
  ObjectDetailProps,
  ObjectPreviewProps,
} from '@open-mercato/shared/modules/messages/types'
import { registerMessageObjectTypes } from '@open-mercato/core/modules/messages/lib/message-objects-registry'
import { configureMessageUiComponentRegistry } from '@open-mercato/core/modules/messages/components/utils/typeUiRegistry'

import * as MSG_TYPES_staff_753 from '@open-mercato/core/modules/staff/message-types'
import * as MSG_TYPES_messages_920 from '@open-mercato/core/modules/messages/message-types'
import * as MSG_TYPES_inbox_ops_1021 from '@open-mercato/core/modules/inbox_ops/message-types'

import * as MSG_OBJECTS_customers_101 from '@open-mercato/core/modules/customers/message-objects'
import * as MSG_OBJECTS_catalog_288 from '@open-mercato/core/modules/catalog/message-objects'
import * as MSG_OBJECTS_sales_350 from '@open-mercato/core/modules/sales/message-objects'
import * as MSG_OBJECTS_currencies_664 from '@open-mercato/core/modules/currencies/message-objects'
import * as MSG_OBJECTS_resources_718 from '@open-mercato/core/modules/resources/message-objects'
import * as MSG_OBJECTS_staff_754 from '@open-mercato/core/modules/staff/message-objects'
import * as MSG_OBJECTS_messages_921 from '@open-mercato/core/modules/messages/message-objects'
import * as MSG_OBJECTS_inbox_ops_1022 from '@open-mercato/core/modules/inbox_ops/message-objects'
import * as MSG_OBJECTS_example_1746 from '../../src/modules/example/message-objects'
type MessageTypeEntry = { moduleId: string; types: MessageTypeDefinition[] }
type MessageObjectTypeEntry = { moduleId: string; types: MessageObjectTypeDefinition[] }

export type MessageListItemRenderers = Record<string, ComponentType<MessageListItemProps>>
export type MessageContentRenderers = Record<string, ComponentType<MessageContentProps>>
export type MessageActionsRenderers = Record<string, ComponentType<MessageActionsProps>>
export type MessageObjectDetailRenderers = Record<string, ComponentType<ObjectDetailProps>>
export type MessageObjectPreviewRenderers = Record<string, ComponentType<ObjectPreviewProps>>

export type MessageUiComponentRegistry = {
  listItemComponents: MessageListItemRenderers
  contentComponents: MessageContentRenderers
  actionsComponents: MessageActionsRenderers
  objectDetailComponents: MessageObjectDetailRenderers
  objectPreviewComponents: MessageObjectPreviewRenderers
}

const messageTypeEntriesRaw: MessageTypeEntry[] = [
  { moduleId: 'staff', types: ((MSG_TYPES_staff_753.default ?? (MSG_TYPES_staff_753 as any).messageTypes ?? (MSG_TYPES_staff_753 as any).types ?? []) as MessageTypeDefinition[]) },
  { moduleId: 'messages', types: ((MSG_TYPES_messages_920.default ?? (MSG_TYPES_messages_920 as any).messageTypes ?? (MSG_TYPES_messages_920 as any).types ?? []) as MessageTypeDefinition[]) },
  { moduleId: 'inbox_ops', types: ((MSG_TYPES_inbox_ops_1021.default ?? (MSG_TYPES_inbox_ops_1021 as any).messageTypes ?? (MSG_TYPES_inbox_ops_1021 as any).types ?? []) as MessageTypeDefinition[]) }
]
const messageObjectTypeEntriesRaw: MessageObjectTypeEntry[] = [
  { moduleId: 'customers', types: ((MSG_OBJECTS_customers_101.default ?? (MSG_OBJECTS_customers_101 as any).messageObjectTypes ?? (MSG_OBJECTS_customers_101 as any).objectTypes ?? (MSG_OBJECTS_customers_101 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'catalog', types: ((MSG_OBJECTS_catalog_288.default ?? (MSG_OBJECTS_catalog_288 as any).messageObjectTypes ?? (MSG_OBJECTS_catalog_288 as any).objectTypes ?? (MSG_OBJECTS_catalog_288 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'sales', types: ((MSG_OBJECTS_sales_350.default ?? (MSG_OBJECTS_sales_350 as any).messageObjectTypes ?? (MSG_OBJECTS_sales_350 as any).objectTypes ?? (MSG_OBJECTS_sales_350 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'currencies', types: ((MSG_OBJECTS_currencies_664.default ?? (MSG_OBJECTS_currencies_664 as any).messageObjectTypes ?? (MSG_OBJECTS_currencies_664 as any).objectTypes ?? (MSG_OBJECTS_currencies_664 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'resources', types: ((MSG_OBJECTS_resources_718.default ?? (MSG_OBJECTS_resources_718 as any).messageObjectTypes ?? (MSG_OBJECTS_resources_718 as any).objectTypes ?? (MSG_OBJECTS_resources_718 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'staff', types: ((MSG_OBJECTS_staff_754.default ?? (MSG_OBJECTS_staff_754 as any).messageObjectTypes ?? (MSG_OBJECTS_staff_754 as any).objectTypes ?? (MSG_OBJECTS_staff_754 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'messages', types: ((MSG_OBJECTS_messages_921.default ?? (MSG_OBJECTS_messages_921 as any).messageObjectTypes ?? (MSG_OBJECTS_messages_921 as any).objectTypes ?? (MSG_OBJECTS_messages_921 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'inbox_ops', types: ((MSG_OBJECTS_inbox_ops_1022.default ?? (MSG_OBJECTS_inbox_ops_1022 as any).messageObjectTypes ?? (MSG_OBJECTS_inbox_ops_1022 as any).objectTypes ?? (MSG_OBJECTS_inbox_ops_1022 as any).types ?? []) as MessageObjectTypeDefinition[]) },
  { moduleId: 'example', types: ((MSG_OBJECTS_example_1746.default ?? (MSG_OBJECTS_example_1746 as any).messageObjectTypes ?? (MSG_OBJECTS_example_1746 as any).objectTypes ?? (MSG_OBJECTS_example_1746 as any).types ?? []) as MessageObjectTypeDefinition[]) }
]

const allMessageTypes = messageTypeEntriesRaw.flatMap((entry) => entry.types)
const allMessageObjectTypes = messageObjectTypeEntriesRaw.flatMap((entry) => entry.types)

const listItemComponents: MessageListItemRenderers = Object.fromEntries(
  allMessageTypes
    .filter((typeDef) => Boolean(typeDef.ui?.listItemComponent) && Boolean(typeDef.ListItemComponent))
    .map((typeDef) => [typeDef.ui!.listItemComponent!, typeDef.ListItemComponent!]),
)

const contentComponents: MessageContentRenderers = Object.fromEntries(
  allMessageTypes
    .filter((typeDef) => Boolean(typeDef.ui?.contentComponent) && Boolean(typeDef.ContentComponent))
    .map((typeDef) => [typeDef.ui!.contentComponent!, typeDef.ContentComponent!]),
)

const actionsComponents: MessageActionsRenderers = Object.fromEntries(
  allMessageTypes
    .filter((typeDef) => Boolean(typeDef.ui?.actionsComponent) && Boolean(typeDef.ActionsComponent))
    .map((typeDef) => [typeDef.ui!.actionsComponent!, typeDef.ActionsComponent!]),
)

const objectDetailComponents: MessageObjectDetailRenderers = Object.fromEntries(
  allMessageObjectTypes
    .filter((typeDef) => Boolean(typeDef.DetailComponent))
    .map((typeDef) => [`${typeDef.module}:${typeDef.entityType}`, typeDef.DetailComponent!]),
)

const objectPreviewComponents: MessageObjectPreviewRenderers = Object.fromEntries(
  allMessageObjectTypes
    .filter((typeDef) => Boolean(typeDef.PreviewComponent))
    .map((typeDef) => [`${typeDef.module}:${typeDef.entityType}`, typeDef.PreviewComponent!]),
)

const registry: MessageUiComponentRegistry = {
  listItemComponents,
  contentComponents,
  actionsComponents,
  objectDetailComponents,
  objectPreviewComponents,
}

export const messageClientTypeEntries = messageTypeEntriesRaw
export const messageClientObjectTypeEntries = messageObjectTypeEntriesRaw
export const messageUiComponentRegistry = registry

export function getMessageUiComponentRegistry(): MessageUiComponentRegistry {
  return registry
}

// Side-effects: register all message object types and configure the UI component registry on import.
for (const entry of messageObjectTypeEntriesRaw) {
  registerMessageObjectTypes(entry.types)
}
configureMessageUiComponentRegistry(registry)
